import { InferredRfqValueMappings } from '@lune-fe/dapi-models'
import { AxiosError } from 'axios'
import { AsyncResult } from 'ts-results-es'

import { notify } from 'bugsnag'
import { inferRfqValueMappings } from 'endpoints/dapi'
import {
    MissingMappingData,
    PARAMETER_MAPPING_OUTPUT,
} from 'views/CalculateEmissions/RFQ/utils/types'

function useLlmValueMapping(
    missingMappings: MissingMappingData[],
): AsyncResult<InferredRfqValueMappings, AxiosError> {
    return inferRfqValueMappings({
        mappedProperties: missingMappings.map((mapping) => ({
            propertyName: mapping.name,
            columnValues: mapping.unmappedValues,
            outputValues: PARAMETER_MAPPING_OUTPUT[mapping.name].map((item) => {
                if (typeof item !== 'string' && typeof item !== 'boolean') {
                    /* The prompt right now is tailored for string to string mapping. If we update the parameter output
                    types, we should be alerted so that we can update the LLM prompt as this will probably affect
                    results */
                    notify(Error(`Unexpected RFQ output value: ${JSON.stringify(item)}`))
                    return JSON.stringify(item)
                }
                return item.toString()
            }),
        })),
    })
}

export { useLlmValueMapping }
